var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8192 2427.2",
    style: {
      enableBackground: "new 0 0 8192 2427.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#A6A6A6;} .st1{fill:#FFFFFF;} .st2{fill:url(#SVGID_1_);} .st3{fill:url(#SVGID_2_);} .st4{fill:url(#SVGID_3_);} .st5{fill:url(#SVGID_4_);} .st6{opacity:0.2;enable-background:new ;} .st7{opacity:0.12;enable-background:new ;} .st8{opacity:0.25;fill:#FFFFFF;enable-background:new ;} ")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7888.6,2427.2H303.4C136.5,2427.2,0,2290.7,0,2123.8V303.4C0,136.5,136.5,0,303.4,0h7585.2 c166.9,0,303.4,136.5,303.4,303.4v1820.5C8192,2290.7,8055.5,2427.2,7888.6,2427.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7888.6,48.5c140.5,0,254.9,114.3,254.9,254.9v1820.5c0,140.5-114.3,254.9-254.9,254.9H303.4 c-140.5,0-254.9-114.3-254.9-254.9V303.4c0-140.5,114.3-254.9,254.9-254.9L7888.6,48.5 M7888.6,0H303.4C136.5,0,0,136.5,0,303.4 v1820.5c0,166.9,136.5,303.4,303.4,303.4h7585.2c166.9,0,303.4-136.5,303.4-303.4V303.4C8192,136.5,8055.5,0,7888.6,0L7888.6,0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4134.6,1319.9c-142.7,0-259,108.5-259,258.1c0,148.6,116.3,258.1,259,258.1c142.7,0,259-109.5,259-258.1 C4393.7,1428.4,4277.3,1319.9,4134.6,1319.9z M4134.6,1734.4c-78.2,0-145.6-64.5-145.6-156.4c0-92.9,67.5-156.4,145.6-156.4 s145.6,63.5,145.6,156.4C4280.3,1669.9,4212.8,1734.4,4134.6,1734.4z M3569.5,1319.9c-142.7,0-259,108.5-259,258.1 c0,148.6,116.3,258.1,259,258.1s259-109.5,259-258.1C3828.5,1428.4,3712.2,1319.9,3569.5,1319.9z M3569.5,1734.4 c-78.2,0-145.6-64.5-145.6-156.4c0-92.9,67.5-156.4,145.6-156.4s145.6,63.5,145.6,156.4C3715.1,1669.9,3647.6,1734.4,3569.5,1734.4 z M2897.2,1399.1v109.5h262c-7.9,61.6-28.4,106.6-59.6,137.9c-38.1,38.1-97.8,80.1-202.3,80.1c-161.3,0-287.4-130-287.4-291.4 s126.1-291.4,287.4-291.4c87,0,150.6,34.2,197.5,78.2l77.2-77.2c-65.5-62.6-152.5-110.5-274.7-110.5 c-221,0-406.7,179.9-406.7,400.8s185.7,400.8,406.7,400.8c119.3,0,209.2-39.1,279.6-112.4c72.3-72.3,94.8-174,94.8-256.1 c0-25.4-2-48.9-5.9-68.4h-368.6V1399.1z M5646.6,1484.2c-21.5-57.6-87-164.2-221-164.2c-133,0-243.4,104.6-243.4,258.1 c0,144.7,109.5,258.1,256.1,258.1c118.3,0,186.7-72.3,215.1-114.3l-88-58.7c-29.3,43-69.4,71.3-127.1,71.3 c-57.7,0-98.8-26.4-125.1-78.2l345.1-142.7L5646.6,1484.2z M5294.6,1570.2c-2.9-99.7,77.2-150.5,134.9-150.5 c45,0,83.1,22.5,95.8,54.7L5294.6,1570.2z M5014,1820.5h113.4v-758.6H5014V1820.5z M4828.2,1377.6h-3.9 c-25.4-30.3-74.3-57.6-135.9-57.6c-129,0-247.3,113.4-247.3,259c0,144.7,118.3,257.1,247.3,257.1c61.6,0,110.5-27.4,135.9-58.7h3.9 v37.1c0,98.8-52.8,151.5-137.9,151.5c-69.4,0-112.4-49.9-130-91.9l-98.8,41.1c28.4,68.4,103.6,152.5,228.8,152.5 c133,0,245.4-78.2,245.4-268.9v-463.4h-107.6L4828.2,1377.6L4828.2,1377.6z M4698.2,1734.4c-78.2,0-143.7-65.5-143.7-155.5 c0-90.9,65.5-157.4,143.7-157.4c77.2,0,137.9,66.5,137.9,157.4C4836.1,1668.9,4775.5,1734.4,4698.2,1734.4z M6177.8,1061.8h-271.3 v758.6h113.2V1533h158.1c125.5,0,248.8-90.8,248.8-235.6C6426.6,1152.7,6303.2,1061.8,6177.8,1061.8z M6180.7,1427.5h-161v-260.1 h161c84.6,0,132.7,70.1,132.7,130C6313.4,1356.2,6265.3,1427.5,6180.7,1427.5z M6880.4,1318.5c-82,0-166.9,36.1-202,116.1 l100.5,41.9c21.5-41.9,61.5-55.6,103.5-55.6c58.5,0,118.1,35.2,119.1,97.6v7.8c-20.5-11.7-64.4-29.3-118.1-29.3 c-108.3,0-218.6,59.6-218.6,170.8c0,101.5,88.8,166.9,188.3,166.9c76.1,0,118.1-34.1,144.4-74.2h3.9v58.5h109.3v-290.8 C7110.7,1393.7,7010.2,1318.5,6880.4,1318.5z M6866.8,1734.3c-37.1,0-88.8-18.6-88.8-64.4c0-58.5,64.4-81,120.1-81 c49.8,0,73.2,10.8,103.5,25.4C6992.6,1684.5,6932.1,1734.3,6866.8,1734.3z M7508.9,1335.1L7379.1,1664h-3.9l-134.7-328.9h-122 l202,459.7l-115.2,255.7h118.1l311.3-715.4L7508.9,1335.1L7508.9,1335.1z M6489.1,1820.5h113.2v-758.6h-113.2V1820.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.8123,
    y1: -4066.5947,
    x2: -1599.7056,
    y2: -2459.0769,
    gradientTransform: "matrix(0.6335 0 0 0.6335 1317.8927 3104.7666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M633.3,457.4c-17.7,18.7-28.1,47.7-28.1,85.3v1342c0,37.6,10.5,66.6,28.1,85.3l4.5,4.4l751.8-751.8v-8.9v-8.9 L637.7,453L633.3,457.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1160.5491,
    y1: -2985.0342,
    x2: -1157.1731,
    y2: -2985.0342,
    gradientTransform: "matrix(0.6335 0 0 0.6335 1317.8927 3104.7666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1640.1,1473.2l-250.6-250.7v-8.9v-8.9l250.6-250.6l5.6,3.2l296.9,168.7c84.8,48.2,84.8,127,0,175.2 l-296.9,168.7L1640.1,1473.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.7523,
    y1: -2765.2349,
    x2: -1882.1702,
    y2: -585.3124,
    gradientTransform: "matrix(0.6335 0 0 0.6335 1317.8927 3104.7666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1645.8,1470l-256.3-256.3L633.3,1970c27.9,29.6,74.1,33.3,126.1,3.7L1645.8,1470"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -1381.3448,
    y1: -4883.981,
    x2: -407.9182,
    y2: -3910.5542,
    gradientTransform: "matrix(0.6335 0 0 0.6335 1317.8927 3104.7666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1645.8,957.4L759.3,453.7c-52-29.5-98.1-25.8-126.1,3.7l756.3,756.3L1645.8,957.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1640.2,1464.4l-880.8,500.5c-49.3,28-93.3,26.1-121.6,0.6l0,0l-4.5,4.5l0,0l4.5,4.4l0,0 c28.3,25.5,72.3,27.4,121.6-0.6l886.5-503.7L1640.2,1464.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M633.3,1961.1c-17.7-18.7-28.1-47.7-28.1-85.3v8.9c0,37.6,10.5,66.6,28.1,85.3l4.5-4.5L633.3,1961.1z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1942.7,1292.4l-302.5,171.9l5.6,5.6l296.9-168.7c42.4-24.1,63.6-55.8,63.6-87.6l0,0 C2002.7,1242.4,1981.2,1270.6,1942.7,1292.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M759.3,462.6l1183.3,672.3c38.5,21.9,60.1,50,63.6,78.7l0,0c0-31.7-21.2-63.5-63.6-87.6L759.3,453.7 c-84.8-48.2-154.2-8.2-154.2,89v8.9C605.1,454.4,674.5,414.4,759.3,462.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2616.1,794.9h-117.5V418.7h117.5c57.3,0,104,17.6,138.5,52.4c34.5,34.7,52.1,80.4,52.1,135.7 s-17.5,101-52.1,135.7C2720.2,777.3,2673.5,794.9,2616.1,794.9z M2557.7,738h58.5c40.2,0,72.4-11.5,95.7-34.4 c23.3-22.7,35-55.4,35-96.9c0-41.2-11.8-73.7-35-96.6c-23.3-22.9-55.5-34.6-95.7-34.6h-58.5V738L2557.7,738z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2919.3,794.9h-58.9V418.7h58.9V794.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3099.3,803c-27.6,0-54.8-9.1-81-27c-26.4-18.1-44-43.8-52.1-76.3l-1.3-5.1l54.1-21.9l1.7,6.7 c4.8,18.8,14.7,34.7,29.3,47.5c14.8,12.9,30.9,19.1,49.2,19.1c18.9,0,35.3-5,48.5-14.8c12.9-9.5,19.1-22.1,19.1-38.6 c0-18.5-6.3-32.3-19.2-42.2c-13.7-10.5-36.1-20.5-66.5-29.8c-33-10.4-58.5-24.1-75.7-40.9c-17.7-17.2-26.7-39.5-26.7-66.1 c0-27.7,11.1-52.1,33-72.5c21.8-20.3,50.4-30.7,85-30.7c32.1,0,58.7,8.2,79.1,24.5c20.2,16.2,33.5,34.1,39.6,53.5l1.6,5.3 l-54.2,22.6l-1.8-6.7c-2.7-10.2-9.7-20-20.7-28.9c-10.8-8.9-25.2-13.4-42.7-13.4c-16.5,0-30.7,4.6-42.2,13.7 c-11.3,8.9-16.8,19.5-16.8,32.6c0,11.7,5,21.4,15.3,29.6c11.1,8.9,27.9,17,49.7,24.1c18.4,6,33.4,11.5,45.6,17 c12.3,5.5,25,13,37.6,22.2c13.1,9.5,23.2,21.6,29.8,35.9c6.7,14.1,10,30.7,10,49.1c0,18.6-3.9,35.4-11.6,50.1 c-7.7,14.7-18.1,26.5-31,35.3c-12.5,8.4-26.2,15-40.5,19.3C3129.4,800.8,3114.3,803,3099.3,803z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3340.8,794.9h-58.9V418.7H3412c32.2,0,60.6,10.9,84.1,32.4c23.8,21.5,35.8,49.2,35.8,82 c0,32.8-12,60.4-35.8,82c-23.6,21.5-51.9,32.4-84.1,32.4h-71.3V794.9z M3340.8,590.6h72.3c18.1,0,32.1-5.8,42.8-17.8 c10.9-12.2,16.2-25.2,16.2-39.7c0-14.5-5.3-27.5-16.2-39.7c-10.8-12-24.8-17.9-42.8-17.9h-72.3V590.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3749.1,803c-54.7,0-101-19.2-137.8-57c-36.7-37.8-55.4-84.6-55.4-139.2c0-54.7,18.6-101.5,55.4-139.2 c36.7-37.8,83.1-57,137.8-57c54.3,0,100.6,19.3,137.6,57.3c36.9,37.9,55.6,84.7,55.6,139c0,54.6-18.6,101.4-55.4,139.2l0,0 C3850.2,783.8,3803.8,803,3749.1,803z M3654.5,707.1c25.7,26,57.5,39.1,94.6,39.1c37.2,0,69-13.2,94.6-39.1 c25.7-26,38.7-59.7,38.7-100.2s-13-74.2-38.7-100.2c-25.6-26-57.4-39.1-94.6-39.1c-37.1,0-68.9,13.2-94.6,39.1 c-25.7,26-38.6,59.7-38.6,100.2S3628.9,681,3654.5,707.1L3654.5,707.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4288.6,794.9h-58.3l-1.8-2.9l-175.4-281.3l1.5,51.1v233h-58.9V418.7h66.4l169,270.5l-1.4-51.2V418.7h58.9 V794.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4418.8,794.9H4360V418.7h58.9V794.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4634.9,794.9h-144.8V418.7h137.7c29.8,0,56.1,10,78.1,29.8c22,20,33.3,45.4,33.3,75.5 c0,18.4-4.9,35-14.5,49.2c-7.5,11.1-17,20.1-28.6,27.1c14.5,6.7,26.9,16.5,36.8,29.4c12.4,16,18.6,34.7,18.6,55.6 c0,31.5-11.7,58-34.8,78.7C4693.6,784.5,4666.1,794.9,4634.9,794.9z M4548.9,738h88.1c16.3,0,29.1-5.5,39.2-16.8 c10.3-11.5,15.2-23.6,15.2-37.2c0-13.4-5.1-25.5-15.7-36.7c-10.5-11.2-23.8-16.7-40.8-16.7h-86V738z M4548.9,574.8h78.9 c16,0,28.5-5.1,38-15.6c9.7-10.6,14.4-21.9,14.4-34.3c0-12.5-4.6-23.6-14-34.1c-9.2-10.3-21.1-15.3-36.4-15.3h-81V574.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5018.8,794.9h-216.5V418.7h58.9V738h157.6V794.9L5018.8,794.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5290.4,794.9h-224.6V418.7h224.6v56.9h-165.8v103.3h149.5v55.9h-149.5V738h165.8V794.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5567,803c-27.6,0-54.8-9.1-81-27c-26.4-18.1-44-43.8-52-76.3l-1.3-5.1l54-21.9l1.7,6.7 c4.8,18.8,14.6,34.7,29.3,47.5c14.8,12.9,30.9,19.1,49.2,19.1c18.9,0,35.3-5,48.5-14.8c12.9-9.5,19.1-22.1,19.1-38.6 c0-18.5-6.3-32.3-19.2-42.2c-13.7-10.5-36.1-20.5-66.5-29.8c-33-10.4-58.5-24.1-75.7-40.9c-17.8-17.2-26.8-39.5-26.8-66.1 c0-27.7,11.1-52.1,32.9-72.5c21.7-20.3,50.4-30.7,85-30.7c32.1,0,58.7,8.2,79.1,24.5c20.2,16.2,33.5,34.1,39.7,53.5l1.6,5.3 l-54.2,22.6l-1.8-6.7c-2.7-10.2-9.6-20-20.7-28.9c-10.8-8.9-25.2-13.4-42.7-13.4c-16.5,0-30.7,4.6-42.3,13.7 c-11.3,8.9-16.8,19.5-16.8,32.6c0,11.7,5.1,21.4,15.3,29.6c11.1,8.9,27.9,17,49.7,24.1c18.5,6,33.4,11.5,45.6,17 c12.3,5.5,25,13,37.6,22.2c13.2,9.5,23.2,21.6,29.9,35.9c6.7,14.1,9.9,30.7,9.9,49.1c0,18.6-3.9,35.4-11.5,50.1 c-7.7,14.7-18.1,26.5-31,35.3c-12.5,8.4-26.2,15-40.5,19.3C5597.1,800.8,5582.2,803,5567,803z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5882.3,803c-41.6,0-75.8-14-101.8-41.6c-25.9-27.5-39-63.8-39-107.9V418.7h58.9v236.9 c0,27.2,7.2,49.4,21.2,66c14,16.5,33.8,24.5,60.8,24.5c26.5,0,46.9-8.2,60.7-24.5c14.1-16.6,21.2-38.8,21.2-66V418.7h58.9v234.9 c0,44.4-12.7,80.8-38,108.1C5959.9,789.1,5925.3,803,5882.3,803z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6350.6,794.9h-64.7l-1.8-2.7l-96.4-144.8h-42.6v147.5h-58.9V418.7h130.1c32.3,0,60.6,10.9,84.1,32.4 c23.8,21.5,35.8,49.2,35.8,82c0,26.8-8.9,50.8-26.4,71.3c-15.8,18.6-35.4,31-58.3,37.2l99,143.4L6350.6,794.9L6350.6,794.9z M6145.1,591.6h69.2c17.2,0,31.7-5.4,44-16.7c12.2-11.1,18.1-24.8,18.1-41.7c0-14.5-5.3-27.5-16.2-39.7 c-10.7-12-24.8-17.9-42.8-17.9h-72.3L6145.1,591.6L6145.1,591.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlayStore);
export default __webpack_public_path__ + "static/media/logo_play_store.d666c8519a30f781607ea8a9731587ce.svg";
export { ForwardRef as ReactComponent };